// Contains various application wide defaults and configurations
const AppSettings = {
  graphUpdateInterval: 30000
}

export default AppSettings